import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DamageImageModel, Question} from '../../models/underwriter.model';
import {DamageQuestionPasser} from '../../services/damage-question-passer';
import {newGuid, parseOptions, getParam} from '../question-helper';

declare var $: any;

@Component({
    selector: 'app-question-pill-buttons',
    templateUrl: './question-pill-buttons.component.html',
    styleUrls: ['./question-pill-buttons.component.scss'],
    standalone: false
})
export class QuestionPillButtonsComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() labelText = 'Activities';
  @Input() items: any[] = [];
  @Input() checkboxSelectedOptions: any[] = [];
  @Input() radioSelectedOption: any;
  @Input() isRadio = true;
  @Input() showLabel = true;
  @Input() isUploadPills = false;
  @Output() questionAnswer = new EventEmitter<any>();

  incidentImages: any[] = [];
  uniqueControlName = this.isRadio ? `radio-button-${newGuid()}` : `checkbox-${newGuid()}`;
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor(private damageImagePasser: DamageQuestionPasser) {
    this.damageImagePasser.updateComponent()
      .subscribe((damageImage: DamageImageModel) => {
        if (!damageImage || damageImage.sender === 'parent') {
          return;
        }
        this.addAreaImage(damageImage);
        this.updateCompletedAreas();
        this.damageImagePasser.setDamageImageModal(false);
      });
  }

  ngOnInit(): void {
    if (this.question?.options?.length) {
      this.items = parseOptions(this.question?.options);
    }
    if (this.question?.answer?.length > 0) {
      let response: any;
      try { response = JSON.parse(this.question.answer); } catch { }
      if (!response) { return; }
      response.forEach((item: any) => {
        this.incidentImages.push({area: item.area, response: item.response});
      });
    }
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
  }

  ngAfterViewInit(): void {
    this.updateCompletedAreas();
  }

  addAreaContent(option: any): void {
    const damageImageModel: DamageImageModel = {
      question: this.question,
      header_copy: `Show the <strong>damage</strong> caused to the <strong>${option.answer}</strong>`,
      response: '',
      side: option.answer,
      sender: 'parent',
      other_side_name: ''
    };

    const areaResponse = this.incidentImages.find((ii: any) => ii.area === option.answer);
    if (areaResponse) {
      damageImageModel.response = areaResponse.response;
    }
    this.damageImagePasser.passDamageQuestion(damageImageModel);
    this.updateCompletedAreas();
    this.damageImagePasser.setDamageImageModal(true);
  }

  addAreaImage(damageImage: DamageImageModel): void {
    if (damageImage.response.length === 0) {
      return;
    }
    const areaExists = this.incidentImages.some((o: any) => o.area === damageImage.side);
    if (areaExists === false) {
      this.incidentImages.push(
        {area: damageImage.side, response: damageImage.response}
      );
    } else {
      const foundIndex = this.incidentImages.findIndex((o: any) => o.area === damageImage.side);
      this.incidentImages[foundIndex].response = damageImage.response;
    }
    this.updateCompletedAreas();
  }

  updateCompletedAreas(): void {
    const elements = document.getElementsByName(`${this.uniqueControlName}`);
    for (const c of elements) {
      const el = c as HTMLInputElement;
      if (el.checked) {
        el.checked = false;
      }
    }

    this.incidentImages.forEach((ii: any) => {
      if (ii.response.length > 0) {
        const side = ii.area;
        for (const c of elements) {
          const el = c as HTMLInputElement;
          if (el.id === side) {
            el.checked = true;
            break;
          }
        }
      }
    });

    if (this.incidentImages.length > 0) {
      this.question.answer = JSON.stringify(this.incidentImages);
      this.questionAnswer.emit(this.question);
    }
  }

  checkIfItemIsChecked(item: any): boolean {
    return this.checkboxSelectedOptions.some(i => i === item);
  }

  checkOption(): void {
    const elements = document.getElementsByName(`${this.uniqueControlName}`);
    if (this.isRadio) {
      let selectedOption = '';

      // @ts-ignore
      for (const c of elements) {
        const el = c as HTMLInputElement;
        if (el.checked) {
          selectedOption = el.value;
        }
      }
      if (selectedOption) {
        this.submitAnswer(selectedOption);
      }
    } else {
      const selectedOptions = [];

      // @ts-ignore
      for (const c of elements) {
        const el = c as HTMLInputElement;
        if (el.checked) {
          selectedOptions.push(el.value);
        }
      }

      if (selectedOptions?.length) {
        this.submitAnswer(selectedOptions.join('|'));
      }
    }
  }

  submitAnswer(value: any): void {
    if (this.question) {
      this.question.answer = value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(value);
    }
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
}
